/* COLLAPSE · animations du site (issues du prototype localhost).
   - Carrousel de la Collection Permanente : voir overrides/assets/collapse-3d.js.
   - Logo du header animé : l'emblème Ξ statique (img.clp-hdr-logo, créé par le thème) est recouvert, à la même place
     et à la même taille, par une miniature du logo 3D de l'ancien écran d'introduction : mêmes pièces chromées
     bleu / blanc / rouge, rotation douce et continue, sans souris ni scroll. L'image d'origine reste dessous : c'est la
     version statique (mouvement réduit, WebGL indisponible, ou tant que la 3D n'a pas rendu sa première image). */
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const HAS_GL = window.__clpGL !== undefined ? window.__clpGL : (() => { try { return !!document.createElement('canvas').getContext('webgl2'); } catch (e) { return false; } })();

// Géométrie du logo, identique à l'écran d'introduction (1 unité = 100 px du logo, centre du Ξ à l'origine).
function roundedShape(THREE, pts) {
  const s = new THREE.Shape(), n = pts.length;
  for (let i = 0; i < n; i++) {
    const [x, y, r] = pts[i], [px, py] = pts[(i - 1 + n) % n], [nx, ny] = pts[(i + 1) % n];
    const l1 = Math.hypot(px - x, py - y), l2 = Math.hypot(nx - x, ny - y);
    const ax = x + ((px - x) / l1) * r, ay = y + ((py - y) / l1) * r;
    const bx = x + ((nx - x) / l2) * r, by = y + ((ny - y) / l2) * r;
    if (i === 0) s.moveTo(ax, ay); else s.lineTo(ax, ay);
    s.quadraticCurveTo(x, y, bx, by);
  }
  s.closePath();
  return s;
}
function neonEnvironment(THREE, renderer) {
  const pm = new THREE.PMREMGenerator(renderer);
  const s = new THREE.Scene();
  s.add(new THREE.Mesh(new THREE.SphereGeometry(30, 32, 16), new THREE.MeshBasicMaterial({ color: 0x040405, side: THREE.BackSide })));
  [[0.7, 16, 0xffffff, 4.0, -8, 0, 7], [0.5, 16, 0xe8ecff, 2.6, 9, 1, 4], [0.6, 14, 0x2a45ff, 5.0, -10, 0, -6], [0.6, 14, 0xff1d2e, 5.0, 10, 0, -6],
    [18, 2.4, 0xffffff, 1.3, 0, 11, 3], [12, 0.4, 0xa24dff, 2.0, 0, -8, 9], [18, 1.1, 0xffffff, 3.2, 0, 2.6, 14], [18, 2.0, 0xdfe4ff, 0.6, 0, -2.6, 14],
    [6, 6, 0xffffff, 0.35, 0, 0, 16], [0.8, 9, 0xffffff, 2.4, -5.5, 0, 13], [0.6, 9, 0xff4a55, 1.4, 5.5, 0, 13]
  ].forEach(([w, h, hex, k, x, y, z]) => {
    const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(hex).multiplyScalar(k), side: THREE.DoubleSide }));
    m.position.set(x, y, z); m.lookAt(0, 0, 0); s.add(m);
  });
  const tex = pm.fromScene(s, 0.035).texture;
  pm.dispose();
  s.traverse((o) => { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose(); });
  return tex;
}

// Le header garde son emblème statique d'origine ; la version animée remplace l'emblème du titre « COLLAPSΞ »
// de la section d'accueil (image placée après « COLLAPS »), à la même place et à la même taille.
async function titleEmblem() {
  const find = () => document.querySelector('.clp-hero2__brand img.clp-hero2__e');
  let img = find();
  for (let k = 0; !img && k < 40; k++) { await new Promise((r) => setTimeout(r, 150)); img = find(); }
  if (!img || REDUCED || !HAS_GL) return;

  const THREE = await import(window.__clpAssets.three);
  const link = img.parentElement;
  img.classList.add('clp-emb-src');
  const canvas = document.createElement('canvas');
  canvas.className = 'clp-emb';
  canvas.setAttribute('aria-hidden', 'true');
  link.appendChild(canvas);

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'low-power' });
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;
  renderer.setClearColor(0x000000, 0);
  const scene = new THREE.Scene();
  scene.environment = neonEnvironment(THREE, renderer);
  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 100);
  camera.position.set(0, 0, 12);
  const key = new THREE.DirectionalLight(0xffffff, 0.9); key.position.set(-3, 4, 6); scene.add(key);
  const fill = new THREE.DirectionalLight(0xffffff, 0.5); fill.position.set(3, -1, 8); scene.add(fill);

  const ext = { depth: 0.34, bevelEnabled: true, bevelThickness: 0.07, bevelSize: 0.05, bevelSegments: 4, curveSegments: 12 };
  const bracket = new THREE.ExtrudeGeometry(roundedShape(THREE, [
    [-1.42, -0.38, 0.05], [-1.18, -0.38, 0.05], [-1.18, -0.08, 0.14], [1.18, -0.08, 0.14],
    [1.18, -0.38, 0.05], [1.42, -0.38, 0.05], [1.42, 0.38, 0.07], [-1.42, 0.38, 0.07]
  ]), ext);
  bracket.translate(0, 0, -0.17);
  const beam = new THREE.ExtrudeGeometry(roundedShape(THREE, [
    [-0.82, -0.52, 0.05], [-0.6, -0.52, 0.05], [-0.6, -0.32, 0.12], [0.6, -0.32, 0.12],
    [0.6, -0.52, 0.05], [0.82, -0.52, 0.05], [0.82, 0.52, 0.05], [0.6, 0.52, 0.05],
    [0.6, 0.32, 0.12], [-0.6, 0.32, 0.12], [-0.6, 0.52, 0.05], [-0.82, 0.52, 0.05]
  ]), ext);
  beam.translate(0, 0, -0.17);
  // Mêmes matières ; un peu plus mates qu'en grand pour éviter le scintillement des reflets à cette taille.
  const mat = (hex, rough) => new THREE.MeshPhysicalMaterial({ color: hex, metalness: 1, roughness: rough, clearcoat: 1, clearcoatRoughness: 0.12, envMapIntensity: 1.3 });
  const emblem = new THREE.Group();
  [[bracket, mat(0x2440e6, 0.28), 1.18, 0], [beam, mat(0xf2f3f6, 0.24), 0, 0], [bracket, mat(0xd3121d, 0.28), -1.18, Math.PI]].forEach(([geo, m, y, rz]) => {
    const mesh = new THREE.Mesh(geo, m); mesh.position.y = y; mesh.rotation.z = rz; emblem.add(mesh);
  });
  scene.add(emblem);

  // Cadrage : le Ξ (≈ 2,9 × 3,1 unités) remplit la case de l'emblème, comme l'image d'origine.
  const vh = 2 * camera.position.z * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2));
  emblem.scale.setScalar((vh * 0.98) / 3.2);
  function size() {
    const w = img.clientWidth || 22, h = img.clientHeight || 22;
    canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
    // exactement la boîte de l'image (position et décalage vertical du thème compris)
    canvas.style.left = img.offsetLeft + 'px'; canvas.style.top = img.offsetTop + 'px';
    const cs = getComputedStyle(img);
    canvas.style.transform = cs.transform === 'none' ? '' : cs.transform;
    canvas.style.filter = cs.filter === 'none' ? '' : cs.filter;   // même ombre portée que l'emblème d'origine
    // suréchantillonnage : bords nets et sans crénelage à ~22 px
    renderer.setPixelRatio(Math.min(3, (devicePixelRatio || 1) * 1.5));
    renderer.setSize(w, h, false);
    camera.aspect = w / h; camera.updateProjectionMatrix();
  }
  size();
  new ResizeObserver(size).observe(img);
  addEventListener('resize', size, { passive: true });

  // Rotation continue et lente (≈ 11 s par oscillation) : on voit la 3D sans agitation.
  let t = 0, last = performance.now(), acc = 0, shown = false, onScreen = true;
  // rendu arrêté quand le titre n'est plus à l'écran
  new IntersectionObserver((en) => { onScreen = en[0].isIntersecting; }).observe(img);
  function frame(now) {
    requestAnimationFrame(frame);
    if (document.hidden || (!onScreen && shown)) { last = now; return; }
    const dt = Math.min((now - last) / 1000, 0.1); last = now;
    acc += dt;
    if (acc < 1 / 30 - 0.004) return;  // 30 images/s suffisent à cette taille (marge : sinon une image sur trois à 60 Hz)
    t += acc; acc = 0;
    emblem.rotation.y = Math.sin(t * 0.55) * 0.45 - 0.06;
    emblem.rotation.x = 0.08 + Math.sin(t * 0.37) * 0.05;
    // Les reflets suivent l'emblème : couleurs stables (jamais « éteint » sur l'image), la 3D reste lisible.
    scene.environmentRotation.set(emblem.rotation.x * 0.6, emblem.rotation.y * 0.75, 0);
    renderer.render(scene, camera);
    if (!shown) { shown = true; link.classList.add('clp-emb-on'); }   // l'image statique ne s'efface qu'une fois la 3D prête
  }
  requestAnimationFrame(frame);
}

// Chargé après la page : n'influence ni l'affichage du header ni celui des sections.
const whenIdle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 600));
new Promise((res) => { if (document.readyState === 'complete') res(); else addEventListener('load', res, { once: true }); })
  .then(() => whenIdle(() => titleEmblem().catch((e) => console.error('[logo animé]', e))));

// Cendres (ambiance + reconstructions) : dès que le DOM est prêt, pour masquer à temps les éléments qui se reforment.
const ashBoot = () => import(window.__clpAssets.ash).then((m) => m.start()).catch((e) => console.error('[cendres]', e));
if (document.readyState === 'loading') addEventListener('DOMContentLoaded', ashBoot, { once: true }); else ashBoot();

// Drop / Collection Temporaire : fiches DOS / FACE gérées par assets/collapse-drop.js (section collapse-drop01).
